import StatusList from './StatusList';

export default StatusList;
